<app-navigation-layout [hideHeader]='true'>
  <span main-container>
    <div *ngFor="let orderLine of orderLines; let orderIndex = index;">
      <app-booking-product-configuration-form *ngIf="isShow(orderLine)"
        (isShowForwardButtonEvent)="udpateOrderLinePartnerFormState($event, orderIndex)"
        (startPersonNumberingEvent)="updateStartPersonNumbering($event)"
        [isPartnerRequired]="isPartnerRequired(orderLine)" [isBirthdayRequired]="isBirthdayRequired(orderLine)"
        [orderLine]="orderLine" [orderIndex]="orderIndex" [startPersonsNumbering]="startPersonsNumbering"
        [isPhoneRequired]="isPhoneRequired(orderLine)" [isAddressRequired]="isAddressRequired(orderLine)"
        [isEmailRequired]="isEmailRequired(orderLine)">
      </app-booking-product-configuration-form>
    </div>
  </span>
  <span menu-container>
    <app-booking-basket-simple-view></app-booking-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBackwardClick()" (forwardClick)="onForwardClick()"
      [forwardError]="forwardError"></app-backward-forward>
  </span>
</app-navigation-layout>
